import { useState } from 'react';
import { IBusinessRegistration } from '../../state/api/types';
import Presenter from './Presenter';
import { IContainerProps } from './types';

const BusinessRegistrationFormContainer = (props: IContainerProps) => {
    const [formData, setFormData] = useState<IBusinessRegistration>(DEFAULT_FORM_VALUE);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>, type: string) => {
        let inputData = e.target.value;
        setFormData({ ...formData, [type]: inputData });
    };

    return (
        <Presenter
            {...props}
            formData={formData}
            onChange={onChange}
        />
    );
};

const DEFAULT_FORM_VALUE: IBusinessRegistration = {
    name: '',
    email: '',
    city: '',
    phone: '',
    businessName: '',
};

export default BusinessRegistrationFormContainer;
